import moment from "moment";
import {
  ElMessage
} from "element-plus";
const helpJs = {
  // 给对象赋值
  assignObj(tar, data) {
    Object.keys(tar).forEach((item) => {
      if (typeof data == "object") {
        tar[item] = data[item];
      } else {
        tar[item] = "";
      }
    });
    return tar;
  },
  // 表格高度
  tableHeight(h = 0) {
    const contentH = document.getElementsByClassName("content-box")[0] ?
      document.getElementsByClassName("content-box")[0].offsetHeight :
      0; // 内容高度
    const topH = document.getElementsByClassName("top")[0] ?
      document.getElementsByClassName("top")[0].offsetHeight :
      0; // 搜索高度
    const pageH = document.getElementsByClassName("el-pagination")[0] ?
      document.getElementsByClassName("el-pagination")[0].offsetHeight :
      0; // 分页高度
    return contentH - topH - pageH - 30 - h;
  },

  /// yyyyhhhhddddhhmmss 转 yyyy-mm-dd hh:mm:ss
  transTime(val) {
    if (val) {
      return `${val.slice(0, 4)}-${val.slice(4, 6)}-${val.slice(
        6,
        8
      )} ${val.slice(8, 10)}:${val.slice(10, 12)}:${val.slice(12, 14)}`;
    }
  },
  // 格式化时间
  formatTime: function (val) {
    return moment(val).format("YYYY-MM-DD HH:mm:ss");
  },

  // 格式化时间
  formatTimeDate: function (val) {
    return moment(val).format("YYYY-MM-DD");
  },

  // 明天时间
  addDateTime: function () {
    return moment().add(1, "days")._d;
  },

  // 入住月份
  // time 选中时间
  // month 输入月份
  checkInTime: function (time, month) {
    return this.formatTime(moment(time).add(month, "months")._d);
  },

  // input 负数检查
  verifyInput: function (e) {
    if (e.keyCode == 189 || e.keyCode == 109) {
      ElMessage({
        showClose: true,
        message: "请输入有效金额",
        type: "error",
      });
      e.target.value = "";
    }
  },
  retainTwoDot(num) {
    // 保留两位小数
    const len = String(num).split(".")[1];
    if (len && len.length >= 2) {
      num = num.replace(/\.\d+/g, "." + len.slice(0, 2));
    }
    return num;
  },
  imgCut: function (img, size = "m") {
    let s = "?x-oss-process=image/resize,m_fill,h_180,w_240";
    let m = "?x-oss-process=image/resize,m_fill,h_360,w_480";
    let l = "?x-oss-process=image/resize,m_fill,h_600,w_800";
    let xl = "?x-oss-process=image/resize,m_fill,h_900,w_1200";
    let a = "?x-oss-process=image/resize,m_fill,h_180,w_180"; //头像尺寸
    let imgUrl;
    if (size === "s") {
      imgUrl = s;
    } else if (size === "m") {
      imgUrl = m;
    } else if (size === "l") {
      imgUrl = l;
    } else if (size === "xl") {
      imgUrl = xl;
    } else if (size === "a") {
      imgUrl = a;
    }
    return img + imgUrl;
  },
  /**
   * 验证身份证号
   */
  validIdCard(value) {
    return /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(
      value
    );
  },
  /**
   * 验证手机格式
   */
  validMobile(value) {
    return /^1[23456789]\d{9}$/.test(value);
  },

  flexColumnWidth(str, tableData, flag) {
    // str为该列的字段名(传字符串);tableData为该表格的数据源(传变量);
    // flag为可选值，可不传该参数,传参时可选'max'或'equal',默认为'max'
    // flag为'max'则设置列宽适配该列中最长的内容,flag为'equal'则设置列宽适配该列中第一行内容的长度。
    str = str + "";
    let columnContent = "";
    if (
      !tableData ||
      !tableData.length ||
      tableData.length === 0 ||
      tableData === undefined
    ) {
      return;
    }
    if (!str || !str.length || str.length === 0 || str === undefined) {
      return;
    }
    if (flag === "equal") {
      // 获取该列中第一个不为空的数据(内容)
      for (let i = 0; i < tableData.length; i++) {
        if (tableData[i][str].length > 0) {
          columnContent = tableData[i][str] + "";
          break;
        }
      }
    } else {
      // 获取该列中最长的数据(内容)
      let index = 0;
      for (let i = 0; i < tableData.length; i++) {
        if (tableData[i][str] === null) {
          // 当数据为空时跳过本次循环获取下一条数据长度
          continue;
        }
        const now_temp = tableData[i][str] + "";
        const max_temp = tableData[index][str] + "";
        if (now_temp.length > max_temp.length) {
          index = i;
        }
      }
      columnContent = tableData[index][str] + "";
    } // 以下分配的单位长度可根据实际需求进行调整
    let flexWidth = 0;
    if (columnContent != undefined) {
      for (const char of columnContent) {
        if ((char >= "A" && char <= "Z") || (char >= "a" && char <= "z")) {
          // 如果是英文字符，为字符分配10个单位宽度
          flexWidth += 10;
        } else if (char >= "\u4e00" && char <= "\u9fa5") {
          // 如果是中文字符，为字符分配16个单位宽度
          flexWidth += 16;
        } else {
          // 其他种类字符，为字符分配10个单位宽度
          flexWidth += 10;
        }
      }
    }
    if (flexWidth < 80) {
      // 设置最小宽度
      flexWidth = 80;
    }
    if (flexWidth > 500) {
      // 设置最大宽度
      flexWidth = 500;
    }
    return flexWidth;
  },

  // 随机 16进制颜色
  color16() {
    let r = Math.floor(Math.random() * 256)
    let g = Math.floor(Math.random() * 256)
    let b = Math.floor(Math.random() * 256)
    let color = `#${r.toString(16)}${g.toString(16)}${b.toString(16)}`
    return color;

    // let r = Math.floor(Math.random() * 256);
    // let g = Math.floor(Math.random() * 256);
    // let b = Math.floor(Math.random() * 256);
    // let color = `#${r.toString(16)}${g.toString(16)}${b.toString(16)}`;
    // return color;
  },

  // 随机生成位数
  getRandomSixNum(n = 6) {
    let RandomSixStr = ''
    for (let i = 0; i < n; i++) {
      RandomSixStr += String(Math.floor(Math.random() * 10))
    }
    return RandomSixStr
  }
};

export default helpJs;